<ng-container *ngIf="formGroup">
  <div class="row">
    <div class="col-6">
      <div class="">
        <div class="h-100 item rounded p-2">
          <div class="col-md-12 p-4 pt-2 pb-0 mt-2">
            <div class="mb-2 border-bottom row">
                <div class="col-md-10">
                  <div class="mogo-header-2 text-start ">Job Information</div>
                </div>
              </div>
          </div>
          <div [formGroup]="formGroup" *ngIf="isInitialized()" class="p-2">


            <div class="row pb-2">
              <label class="col-3 mt-2 text-end mogo-bold" >Freight Payer:</label>
              <div class="col-9">
                <ng-select id="FPDropdown" formControlName="freightPayer" placeholder="Select Freight Payer" bindLabel="name"
                  [items]="freightPayers"
                  >
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="text-md-start">
                      {{ item.name }}
                    </div>
                </ng-template>
                </ng-select>
              </div>
            </div>

            <div class="row pb-2">
              <label class="col-3 mt-2 text-end mogo-bold" >Type of Job:</label>
              <div class="col-9">
                <ng-select id="JobTypeDropdown" formControlName="jobType" placeholder="Select Job type"  bindLabel="name"
                    [items]="jobTypes">
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                      <div class="text-md-start">
                        {{ item.name }}
                      </div>
                  </ng-template>
                </ng-select>
              </div>
            </div>

            @if (liveLoadLabel) {
              <div class="row pb-2">
                <label for="live-load" class="col-3 mt-2 text-end mogo-bold">{{ liveLoadLabel }}:</label>
                <div class="col-1 mt-2">
                  <input id="live-load" type="checkbox" formControlName="liveLoad" />
                </div>
              </div>
            }
            @if (formGroup.hasError('liveLoadFullLegOnly')) {
              <div class="text-danger">Live load/unload and Full Leg Only cannot both be selected.</div>
            }

            <div class="row pb-2" *ngIf="abstractContainerJobTypeHelper.isFullLegOnlyAvailable(getSelectedJobType())">
              <label class="col-3 mt-2 text-end mogo-bold" >Full Leg Only:</label>
              <div class="col-1 mt-2">
                <input type="checkbox" formControlName="fullLegOnly" />
              </div>
            </div>

            <div class="row pb-2" >
              <label class="col-3 mt-2 text-end mogo-bold" >Order Number:</label>
              <div class="col-9">
                <input type="text" formControlName="orderNumber" placeholder="Enter Order Number"
                  class="form-control text-capitalize" id="order-number"/>
              </div>
            </div>

            <div class="row pb-2">
              <label class="col-3 mt-2 text-end mogo-bold" >Customer Reference #:</label>
              <div class="col-9">
                <input type="text" formControlName="customerReference" placeholder="Enter Customer Reference #"
                    class="form-control text-capitalize" id="customer-reference"/>
              </div>
            </div>
            <div class="row pb-2" *ngIf="abstractContainerJobTypeHelper.isImportJob(getSelectedJobType())">
              <label class="col-3 mt-2 text-end mogo-bold" >TSW ID:</label>
              <div class="col-9">
                <input
                    type="text"
                    formControlName="tswId"
                    placeholder="Enter TSW ID"
                    class="form-control text-capitalize"
                    id="tsw-id"
                  />
              </div>
            </div>
            <div class="row pb-2">
              <label class="col-3 mt-2 text-end mogo-bold" >ECN:</label>
              <div class="col-9">
                <input
                    type="text"
                    formControlName="ecn"
                    placeholder="Enter ECN"
                    class="form-control text-capitalize"
                    id="ecn"
                  />
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>

    <div class="row col-6">
      <div class="">
        <div class="h-100 item rounded p-2">
          <div class="col-md-12 p-4 pt-2 pb-0 mt-2">
            <div class="mb-2 border-bottom row">
                <div class="col-md-10">
                  <div class="mogo-header-2 text-start ">Container Information</div>
                </div>
              </div>
          </div>

          <div [formGroup]="formGroup" *ngIf="isInitialized()" class="p-2">

              <div class="row pb-2">
                <label class="col-3 mt-2 text-end mogo-bold" >Container Size:</label>
                <div class="col-9">
                  <ng-select formControlName="containerSize" [items]="containerSizes" bindLabel="code"
                      placeholder="Select container size">
                      <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                        <div class="text-md-start">
                          {{ item.code }}
                        </div>
                    </ng-template>
                  </ng-select>
                </div>
              </div>

              <div class="row pb-2">
                <label class="col-3 mt-2 text-end mogo-bold" >Container Type:</label>
                <div class="col-9">
                  <ng-select formControlName="containerType" [items]="containerTypes" bindLabel="display"
                      placeholder="Select the container type">
                      <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                        <div class="text-md-start">
                          {{ item.display }}
                        </div>
                    </ng-template>
                  </ng-select>
                </div>
              </div>

              <div class="row pb-2"  *ngIf="formGroup.get('containerType') && formGroup.get('containerType')!.value && formGroup.get('containerType')!.value.code === 'RF'">
                <label class="col-3 mt-2 text-end mogo-bold" >Temperature &deg;C:</label>
                <div class="col-9">
                  <input type="number" formControlName="temperatureValue"
                    class="form-control" inputmode="numeric"/>
                </div>
              </div> 

              <div class="row pb-2"  *ngIf="showHighGauge()">
                <label class="col-3 mt-2 text-end mogo-bold" >Gauge:</label>
                <div class="col-3 mt-2" *ngIf="showHighGauge()">
                  <span class="mogo-bold mx-2">High:</span>
                  <input type="checkbox" formControlName="isHighGauge" />
                </div>
                <div class="col-3  mt-2" *ngIf="showWideGauge()">
                  <span class="mogo-bold mx-2">Wide:</span>

                  <input type="checkbox" formControlName="isWideGauge" />
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
  </div>
</ng-container>
